import { render, staticRenderFns } from "./PackageProductsCardWrapper.vue?vue&type=template&id=6cf220a8&scoped=true&"
import script from "./PackageProductsCardWrapper.vue?vue&type=script&lang=js&"
export * from "./PackageProductsCardWrapper.vue?vue&type=script&lang=js&"
import style0 from "./PackageProductsCardWrapper.vue?vue&type=style&index=0&id=6cf220a8&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf220a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VRow})
